import React, { Component } from "react";
import { Alert, Row, Col, Button, FormGroup, Label, Input, Spinner} from 'reactstrap';
import axios from '../../utils/request';

export class CxmtConfirmToSend extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: "",
            loading: true,
            code: "",
            tenantId: - 1,
            showError: false,
            showErrorMsg: "",
            commonParamater: "",
            emailVersion:"Chinese"
        }
    };

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const commonParamater = urlParams.get("commonParamater");
        const tenantId = urlParams.get("tenantId");
        if (!commonParamater) {
            this.setState({ code: "500", message: "参数异常，请联系管理员。", loading: false });
            return;
        }
        this.setState({ code: "100", message: "", tenantId: tenantId, commonParamater: commonParamater, loading: false });
    };

    showError = (text) => {
        this.setState({ showErrorMsg: text, showError: true })
    }

    errDismiss = () => {
        const isErrorShowing = this.state.showError;
        if (isErrorShowing) {
            this.setState({ showError: false })
        }
        else {
            this.setState({ showError: true })
        }
    };

    submitFun = () => {

        this.setState({ code: "201", loading: true });
        const tenantId = this.state.tenantId;
        const commonParamater = this.state.commonParamater;
        const emailVersion = this.state.emailVersion;//$("emailVersion").value();
        const param = {
            tenantId,
            emailVersion,
            commonParamater
        };
        axios.get(
            "/api/Cxmt/SendSalaryCollectionLink", { params: param }
        )
            .then(res => {
                const codeValue = res.data.code;
                let msg = "";
                if (codeValue === "500") {

                    this.setState({ code: codeValue, message: res.data.message, loading: false });
                } else {
                    this.setState({ code: "200", message: "", loading: false })
                }
            })
            .catch(reason => {
                alert(reason);
                this.setState({ code: "500", message: "发起失败，请稍后再试！", loading: false })
            });
    };

    emailVersion = (v) => {
        this.state.emailVersion = v;
    }

    renderHtml = () => {
        return (
            <Col sm="12" md={{ size: 8, offset: 2 }} style={{ marginTop: '50px' }}>
                <Alert color="light">
                    <h4 className="alert-heading">确认发送</h4>
                    {/*<hr />*/}
                    <Row>
                        <Col sm="12" md="12" style={{ marginTop: '12pt' }}>
                            <FormGroup check>
                                <Label check>
                                    <Input type="radio" name="emailVersion" value="Chinese" onChange={() => this.emailVersion("Chinese")} /> 中文邮件/Chinese version of email <br />
                                    <Input type="radio" name="emailVersion" value="English" onChange={() => this.emailVersion("English")} /> 英文邮件/English version of email
                                </Label>
                            </FormGroup>
                            {/*<Button color="primary" onClick={this.submitFun}>取消</Button>*/}
                        </Col>
                        <Col sm="12" md="12" style={{ marginTop: '12pt' }}>
                            <Alert color="danger" isOpen={this.state.showError} toggle={this.errDismiss}>{this.state.showErrorMsg}</Alert>
                            <hr className="my-2" />
                            <Button color="primary" onClick={this.submitFun}>确认</Button>
                            {/*<Button color="primary" onClick={this.submitFun}>取消</Button>*/}
                        </Col>
                    </Row>
                </Alert>
            </Col>
        );
    }

    renderSendedHtml = () => {
        return (
            <Col sm="12" md={{ size: 8, offset: 2 }} style={{ marginTop: '50px' }}>
                <Alert color="light">
                    <h4 className="alert-heading">发送成功</h4>
                    <hr />
                </Alert>
            </Col>
        );
    }

    renderSendingHtml = () => {
        return (
            <Col sm="12" md={{ size: 8, offset: 2 }} style={{ marginTop: '50px' }}>
                <Alert color="light">
                    <h4 className="alert-heading">发送中</h4>
                    <hr />
                </Alert>
            </Col>
        );
    }

    render() {
        let contents = ""
        if (this.state.loading) {
            contents = ""
            contents = <div style={{ textAlign: "center", padding: "15px" }}>
                <Spinner type="grow" color="primary" />
                <Spinner type="grow" color="secondary" />
                <Spinner type="grow" color="success" />
                <Spinner type="grow" color="danger" />
                <Spinner type="grow" color="warning" />
                <Spinner type="grow" color="info" />
                <Spinner type="grow" color="light" />
                <Spinner type="grow" color="dark" />
            </div>
        } else {
            contents = ""

            if (this.state.code === "100") {
                contents = this.renderHtml()
            } else if (this.state.code === "201") {
                contents = this.renderSendingHtml()
            } else if (this.state.code === "200") {
                contents = this.renderSendedHtml()
            } else {
                contents = <p><em>Error...</em> | Code = {this.state.code} | Message = {this.state.message}</p>
            }
        }

        return (
            <div>{contents}</div>
        );
    }
}